import React from "react";
import NewsImg from "../../../assets/investor/news.png";
import CareerImg from "../../../assets/investor/careers.png";
import TenderImg from "../../../assets/investor/tender.png";
import { Link } from "react-router-dom";

function CorporateBottomCardListing() {

    const infoData = [
        {
            no: "01",  
            title: "News",
            description: "Unveiling the financial journey: A snapshot of our fiscal achievements and milestones.",
            link: "/news",
            image: NewsImg,
        },
        {
            no: "02",  
            title: "Careers",
            description: "Meet our accomplished Board of Directors and dedicated Senior Management Team, leading us towards a brighter future.",
            link: "/career",
            image: CareerImg,
        },
        {
            no: "03",  
            title: "Procurement",
            description: "You'll find a detailed summary of our accomplishments and progress throughout the year here.",
            link: "/procurement",
            image: TenderImg,
        },
    ];

    return (
        <>
        <div className="investor-home-bottom-section">
            <div className="invest-home-bottom-gallery">
                {infoData.map((item, index) => (
                <Link
                    to={item.link}
                    key={index}
                    className="bottom-card"
                    style={{
                        backgroundImage: `url("${item.image}")`,
                    }}
                >
                    <div className="overlay-bottom-card"></div>
                    <div className={"bottom_card_subs"}>
                    <div id="number_title_subs" style={{ padding:"150px 50px 50px 50px" }}>
                        <h2 style={{marginTop: "250px", color:"white" }}>
                        {item.title}
                        </h2>
                    </div>
                    </div>
                </Link>
                ))}
            </div>

            {/* mobile view */}
            <div className="investor-home-bottom-section">
            <div className="invest-home-bottom-gallery-mobile">
                {infoData.map((item, index) => (
                <Link
                    to={item.link}
                    key={index}
                    className="bottom-card"
                    style={{
                        backgroundImage: `url("${item.image}")`,
                    }}
                >
                    <div className="overlay-bottom-card"></div>
                    <div className={"bottom_card_subs"}>
                    <div id="number_title_subs" style={{ padding:"50px" }}>
                        <h2 style={{marginTop: "200px", marginBottom: "30px", color:"white" }}>
                        {item.title}
                        </h2>
                    </div>
                    </div>
                </Link>
                ))}
            </div>
            </div>
        </div>
        </>
    )
}

export default CorporateBottomCardListing;